import Version from './version';

export default (ua) => {
  const os = {
    name: 'unknown',
    version: new Version('0.0.0'),
  };

  let matched = ua.match(/Windows\sPhone\s(?:OS\s)?([\d.]+)/);

  if (matched) {
    os.name = 'Windows Phone';
    os.isWindowsPhone = true;
    os.version = new Version(matched[1]);
    return os;
  }

  matched = ua.match(/Android[\s/]([\d.]+)/);
  if (matched) {
    os.name = 'Android';
    os.isAndroid = true;
    os.version = new Version(matched[1]);
    return os;
  }

  matched = ua.match(/(iPhone|iPad|iPod)/);
  if (matched) {
    const [, name] = matched;

    matched = ua.match(/OS ([\d_.]+) like Mac OS X/);
    if (matched) {
      os.name = name;
      os.isIPhone = (name === 'iPhone' || name === 'iPod');
      os.isIPad = name === 'iPad';
      os.isIOS = true;
      os.version = new Version(matched[1].split('_').join('.'));
    }

    return os;
  }

  matched = ua.match(/Mac OS X ([\d_.]+)/);
  if (ua.match(/Macintosh/) && matched) {
    os.name = 'Mac';
    os.isMac = true;
    os.version = new Version(matched[1].replace(/_/g, '.'));
    return os;
  }

  matched = ua.match(/Windows NT ([\d_.]+)/);
  if (matched) {
    os.name = 'Windows';
    os.isWindows = true;
    os.version = new Version(matched[1].replace(/_/g, '.'));
    return os;
  }

  return os;
};
